import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API } from '@configs/api.config';
import { JobFile } from '@core/models/job-file';
import { User } from '@core/models/user.model';
import { JobFileCreationDTO } from '@shared/models/job-file-creation.model';
import { Pageable } from '@shared/models/pageable.model';
import { TaskFeedJob } from '@shared/models/task-feed-job.model';
import * as internal from 'assert';
import { Observable } from 'rxjs';
import { JobGroup } from '../models/job-group.model';
import { Jpm } from '@control-tower/models/jpm';

@Injectable({providedIn: 'root'})
export class JobGroupService {
  constructor(private http: HttpClient) {}


  getJobGroups(orgId: string, pageNum: number, pageSize: number, searchKey = ''): Observable<Pageable<JobGroup>> {
    const url = API.jobFile.getJobGroupsWithRelatedJobs.format([orgId, `${pageNum}`, `${pageSize}`]);
    const newUrl = `${url}?searchKey=${searchKey}`;
    return this.http.get<Pageable<JobGroup>> (newUrl);
  }


  createJobGroup(jb: JobGroup): Observable<JobGroup> {
    const url = API.jobFile.createJobGroup;
    return this.http.post<JobGroup>(url, jb);
  }

  updateJobGroup(jb: JobGroup): Observable<JobGroup> {
    const url = API.jobFile.createJobGroup;
    return this.http.put<JobGroup> (url, jb);
  }

  deleteJobGroup(jobGroupId: string): Observable<any> {
    const url = API.jobFile.deleteJobGroup.format([jobGroupId]);
    return this.http.delete(url);
  }

  getJobFiles(jobGroupId: string, pageNum: number, pageSize: number, searchKey: string) {

    let url = API.jobFile.getJobFilesByJobGroupId.format([`${pageNum}`, `${pageSize}`]);
    if (jobGroupId) {
      url = `${url}&jobGroupId=${jobGroupId}`;
    }
    if (searchKey) {
      url = `${url}&searchKey=${searchKey}`;
    }
    return this.http.get<Pageable<JobFile>>(url);
  }

  createJobFile(jobFileCreationModel: JobFileCreationDTO): Observable<JobFileCreationDTO> {
    const url = API.jobFile.createJobFile;
    return this.http.post<JobFileCreationDTO>(url, jobFileCreationModel);
  }

  createJobFileV2(jobFileCreationModel: JobFileCreationDTO): Observable<JobFileCreationDTO> {
    const url = API.jobFile.createJobFileV2;
    return this.http.post<JobFileCreationDTO>(url, jobFileCreationModel);
  }

  fetchUsersByScopes(scopes: string[], pageNum: number, pageSize: number, searchKey?: string): Observable<Pageable<User>> {
    let url = API.organization.getOrgUserByScopes.format([`${pageNum}`, `${pageSize}`]);

    if (searchKey) {
      url = `${url}&searchKey=${searchKey}`;
    }
    return this.http.post<Pageable<User>>(url, scopes);
  }

  getOrLogsByOrgIds(orgIds: string[]): Observable<string[]> {
    const url = API.organization.getOrgLogos;
    return this.http.post<string[]>(url, orgIds);
  }

  getTaskFeedJobFromJobRefId(orgId: string, jobRefId: string): Observable<TaskFeedJob> {
    const url = API.jobFile.getTaskFeedJobByJobRefId.format([orgId, jobRefId]);
    return this.http.get<TaskFeedJob>(url);
  }

  moveJobFileToGroup(orgId: string, jobRefIds: string[], newJobGroupId: string): Observable<boolean> {
    const url = API.jobFile.moveJobFileToGroup;
    return this.http.post<boolean>(url, {orgId, jobRefIds , newJobGroupId});
  }

  getJpms(orgId: string, jobRefId: string, principalId = ""): Observable<Jpm[]> {
    const url = API.jpm.getJpms.format([orgId, jobRefId]);
    let params = new HttpParams();
    params = params.append('principalId', principalId);
    return this.http.get<Jpm[]>(url, {params});
  }
}
